import { INPUT_CLASSES } from '../../../Input';
import { PackageNameFieldBase } from '../../../shared/PackageNameFieldBase';

interface PackageNameFieldProps {
  value: string;
}

export function PackageNameField({ value }: PackageNameFieldProps) {
  return (
    <PackageNameFieldBase
      value={value}
      disabled
      inputClassName={`${INPUT_CLASSES} bg-seeker-900`}
    />
  );
}
